import { Button } from "@/components/ui/button";
import { ArrowUpRight } from "lucide-react";
import DemoModal from "./DemoModal";
import { PRODUCT_LIVE, REGISTER_URL, APP_URL } from "@/lib/api";
import { useSession } from "@/lib/session";

/**
 * Primary signup CTA. Behaviour switches on PRODUCT_LIVE in /lib/api.js.
 *  - When PRODUCT_LIVE && logged-in: links to app.pipeguide.tech (dashboard).
 *  - When PRODUCT_LIVE && anon: links to app.pipeguide.tech/register (with optional ?plan=).
 *  - When NOT live: opens the Early-Access demo modal so leads still land in MongoDB + email.
 *
 * Props mirror the shadcn <Button>: variant, className, etc.
 */
export default function EarlyAccessCta({
    label,           // override default label
    plan,            // optional plan slug (pro/business) appended as ?plan=
    className = "",
    variant,
    size,
    "data-testid": dataTestId,
    children,
    iconRight = true,
}) {
    const { loggedIn } = useSession();
    const liveLabel = label || (loggedIn ? "Go to dashboard" : "Start Free");
    const earlyLabel = label || "Get Early Access";
    const Inner = ({ text }) => (
        <>
            {children || text}
            {iconRight && <ArrowUpRight className="ml-1 h-4 w-4" />}
        </>
    );

    if (PRODUCT_LIVE) {
        const href = loggedIn
            ? APP_URL
            : (plan ? `${REGISTER_URL}?plan=${plan}` : REGISTER_URL);
        return (
            <Button asChild data-testid={dataTestId} variant={variant} size={size} className={className}>
                <a href={href}><Inner text={liveLabel} /></a>
            </Button>
        );
    }

    return (
        <DemoModal
            trigger={
                <Button data-testid={dataTestId} variant={variant} size={size} className={className}>
                    <Inner text={earlyLabel} />
                </Button>
            }
        />
    );
}
